module.exports = __webpack_public_path__ + "media/images/icons/checkmark-94d128efd051661a94df22e517d9e626.svg";